<template>
  <div class="flex items-center gap-1">
    <select v-model="d" class="form-select px-2 w-[4.5rem]" :aria-label="`${label} วัน`" @change="commit">
      <option value="">วัน</option>
      <option v-for="n in daysInMonth" :key="n" :value="n">{{ n }}</option>
    </select>
    <select v-model="m" class="form-select px-2 flex-1 min-w-[6.5rem]" :aria-label="`${label} เดือน`" @change="commit">
      <option value="">เดือน</option>
      <option v-for="(name, i) in TH_MONTHS" :key="i" :value="i + 1">{{ name }}</option>
    </select>
    <select v-model="y" class="form-select px-2 w-[5.75rem]" :aria-label="`${label} ปี พ.ศ.`" @change="commit">
      <option value="">ปี พ.ศ.</option>
      <option v-for="n in years" :key="n" :value="n">{{ n }}</option>
    </select>
    <button v-if="modelValue || d || m || y" type="button" class="icon-btn icon-btn-plain flex-shrink-0" title="ล้างวันที่" @click="clear"><XIcon class="w-3.5 h-3.5" /></button>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { BE_OFFSET, TH_MONTHS, currentYearBE } from "../period";

/** day / month / พ.ศ. selects bound to an ISO date string (YYYY-MM-DD) or null */
const props = defineProps({
  modelValue: { type: String, default: null },
  label: { type: String, default: "วันที่" },
});
const emit = defineEmits(["update:modelValue"]);

const d = ref(""); const m = ref(""); const y = ref("");
const fromModel = (iso) => {
  const hit = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  d.value = hit ? Number(hit[3]) : ""; m.value = hit ? Number(hit[2]) : ""; y.value = hit ? Number(hit[1]) + BE_OFFSET : "";
};
fromModel(props.modelValue);
watch(() => props.modelValue, (v) => { if (v !== toISO()) fromModel(v); });

const daysInMonth = computed(() => (m.value ? new Date((y.value || 2568) - BE_OFFSET, m.value, 0).getDate() : 31));
const years = computed(() => {
  const now = currentYearBE();
  const list = [];
  for (let n = now - 5; n <= now + 10; n++) list.push(n);
  if (y.value && !list.includes(y.value)) list.push(y.value);
  return list.sort((a, b) => a - b);
});

const pad = (n) => String(n).padStart(2, "0");
function toISO() {
  return d.value && m.value && y.value ? `${y.value - BE_OFFSET}-${pad(m.value)}-${pad(d.value)}` : null;
}
function commit() {
  if (d.value && d.value > daysInMonth.value) d.value = daysInMonth.value;   // 31 -> 30 / 28 when the month changes
  emit("update:modelValue", toISO());   // null until all three parts are chosen
}
function clear() { d.value = ""; m.value = ""; y.value = ""; emit("update:modelValue", null); }
</script>
